export default __webpack_public_path__ + "static/media/doctorincentives.77dbc15f.png";